import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 新增主营产品
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/saveMainProduct`, params),
    //查询主营产品
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-member/member/getMainProductList`, params),
    //修改主营产品
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/updateMainProduct`, params),
    //删除主营产品
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/member/deleteMainProduct`, params),
}